module.exports = __webpack_public_path__ + "static/media/intuety-logo.cca6170a.svg";